import React, { Component } from 'react';
import { NavLink} from 'reactstrap'
import { Sidebar, Segment, Menu, Icon, Accordion } from 'semantic-ui-react'
import {BrowserRouter, Route, Switch, Link} from 'react-router-dom'
import {Image} from 'react-bootstrap'
import { connect } from 'react-redux'

import '../styles/navigation.css'

import Home from './Home'
import CreateUser from './CreateUser';
import Users from './ManageUsers';
import Search from './ManageContent';
import CreateContent from './CreateContent';
import CreateChallenge from './CreateChallenge'
import ModifyContent from './ModifyContent'

import tree from '../images/tree.png'

let css = {
  accord: {
    'textAlign': 'left'
  },
  pdg0: {
    'paddingRight': 0,
    'paddingLeft': 0,
    'marginRight': 0,
    'marginLeft': 0,
    'textAlign': 'left',
    'color': 'orange',
    'paddingTop': '20%'
  },
  width20: {
    'width': '20vw'
  },
  mrgTop0: {
    'marginTop': 0
  },
  orange: {
    'color': 'orange'
  },
  title: {
    'color': 'orange',
    'fontWeight': 'bold'
  }
}

class Navigation extends Component {
  constructor(props){
    super(props)
    this.state = {
      visible: this.props.visible
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  render () {
    const { activeIndex } = this.state

    return (
      <div className={'h100vh'}>
        <BrowserRouter forceRefresh={false}>
          <div>

        <div style={css.mrgTop0}>
          <Sidebar className={'bg-ititoca'} width='thin' visible={true} icon='labeled' >
            <Menu.Item style={css.pdg0} name='home'>
            <Segment className={'bg-ititoca'} inverted>
              <div className={''}>
                <Image src={tree} responsive className={'imgResponsive'} />
              </div>
              <Accordion >

                <NavLink className={'yellow-ititoca menu bg-menu'} tag={Link} to='/'><i className={'home icon'}></i> Accueil</NavLink>


                <Accordion.Title className={'yellow-ititoca'} style={css.pdg0} active={activeIndex === 1} index={1} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Utilisateurs
                </Accordion.Title>
                <Accordion.Content className={'bg-menu nopadding'} active={activeIndex === 1}>
                    <NavLink className={'yellow-ititoca txtcenter menu font-b'} tag={Link} activeclassname='selected' to='/manageUsers'>Gerer</NavLink>
                    <NavLink className={'yellow-ititoca txtcenter menu font-b'} tag={Link} to='/createUsers'>Créer</NavLink>
                </Accordion.Content>

                <Accordion.Title className={'yellow-ititoca'}   style={css.pdg0} active={activeIndex === 2} index={2} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Contenus
                </Accordion.Title>
                <Accordion.Content className={'bg-menu nopadding'} active={activeIndex === 2}>
                  <NavLink className={'yellow-ititoca txtcenter menu font-b'} tag={Link} activeclassname='selected' to='/manageContent'>Gerer</NavLink>
                  <NavLink className={'yellow-ititoca txtcenter menu font-b'} tag={Link} to='/createContent'>Créer un Article</NavLink>
                  <NavLink className={'yellow-ititoca txtcenter menu font-b'} tag={Link} activeclassname='selected' to='/createChallenge'> Créer un Challenge </NavLink>
                </Accordion.Content>
              </Accordion>
            </Segment>
            </Menu.Item>
          </Sidebar>
          <div className={'margin-sidebar'}>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route path='/manageUsers' component={Users} />
            <Route path='/createUsers' component={CreateUser} />
            <Route path='/manageContent' component={Search} />
            <Route path='/modifyContent' component={ModifyContent} />
            <Route path='/createContent' component={CreateContent} />
            <Route path='/createChallenge' component={CreateChallenge} />
          </Switch>
          </div>
        </div>
        </div>
        </BrowserRouter>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, null)(Navigation)



// WEBPACK FOOTER //
// ./src/components/Navigation.js